export const CLINIC_REQUEST_START = 'CLINIC_REQUEST_START';
export const FETCH_CLINICS_SUCCESS = 'FETCH_CLINICS_SUCCESS';
export const FETCH_CLINICS_ERROR = 'FETCH_CLINICS_ERROR';
export const LOAD_MORE_CLINICS_SUCCESS = 'LOAD_MORE_CLINICS_SUCCESS';
